exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.header-container[data-v-988460ca] {\n\tpadding-bottom: 24px;\n\tcolor: white;\n}\n.col-center[data-v-988460ca] {\n\tdisplay: flex;\n\tjustify-content: center;\n}\n.action-card[data-v-988460ca] {\n\tcursor: pointer;\n\twidth: 240px;\n\theight: 100px;\n\ttext-align: center;\n\tpadding: 0 !important;\n\tbackground-color: rgba(52, 170, 58, 0.7);\n}\n.action-card-body[data-v-988460ca] {\n\theight: 80px;\n\tpadding: 0 !important;\n}\n.card-title[data-v-988460ca] {\n\ttext-align: center;\n}\n", ""]);

// exports
